import { Link as MuiLink, Typography } from "@mui/material";

/**
 * The way out when the document is not in the picker's list.
 *
 * Phrased as what happens next rather than as a second way to attach: the two
 * kinds do different things after the upload, and saying "upload" alone leaves
 * the reader guessing whether they are done.
 *
 * A manifest goes through the pipeline and shows up in the list to be linked
 * later. A bill of lading is read, confirmed by the reviewer, and attached on
 * the spot. That difference is the `outcome` sentence, which is why it is the
 * caller's to supply rather than a constant here.
 */
export function UploadFallback({
  onUpload,
  outcome,
}: {
  onUpload: () => void;
  /** What happens after the upload, in the reader's terms. */
  outcome: string;
}) {
  return (
    <Typography variant="body2" color="text.secondary">
      Not here?{" "}
      <MuiLink component="button" type="button" onClick={onUpload}>
        Upload the vendor&apos;s copy
      </MuiLink>
      . {outcome}
    </Typography>
  );
}
